<template>
    <div class="header container is-fluid">
        <Filter @filterChanged="handleFilterChange" :initialFilter="filter"/>
        <h1 class="menu-list-title pb-4">Speiseplan</h1>
    </div>
    <WeekSlider @selectedWeek="handleSelectedWeekChange" :initialDate="new Date()"/>
        <DesktopToggle :desktop-list="desktopListVisible"/>
        <div class="container is-fluid" :class="desktopListVisible?'desktop-list':'desktop'">
            <div v-if="isLoading">
                <Loader/>
            </div>
            <div v-else>
              <div v-if="errorLoadingMeals" class="error-message">
                Fehler beim Laden des Speiseplans
              </div>
              <div v-else>
                <vue-collapsible-panel-group v-if="isAccordion===true" :accordion="true"
                                             base-color="#00000000"
                                             border-color="#00000000"
                                             bg-color-header="#00000000"
                                             bg-color-header-hover="#00000000"
                                             bg-color-header-active="#00000000">
                  <DayList
                      v-for="(mealsForDay, day) of meals"
                      :key="day"
                      :meals-of-the-day="mealsForDay"
                      :date="day"
                      :filter="filter"
                      :expand="false"
                  />
                </vue-collapsible-panel-group>
                <div v-else
                     class="is-flex is-flex-direction-row is-flex-wrap-nowrap is-justify-content-flex-start is-justify-content-space-between">
                  <DayList
                      v-for="(mealsForDay, day) of meals"
                      :key="day"
                      :meals-of-the-day="mealsForDay"
                      :date="day"
                      :filter="filter"
                      :expand="true"
                  />
                </div>
              </div>
            </div>
        </div>
</template>
<script>
import Filter from "@/views/components/ui/PublicMenuPlan/Filter";
import WeekSlider from "@/views/components/ui/PublicMenuPlan/WeekSlider";
import DesktopToggle from "@/views/components/ui/DesktopToggle"
import Loader from "@/views/components/ui/Loader";
import DayList from "@/views/components/ui/PublicMenuPlan/DayList";
import {VueCollapsiblePanelGroup} from '@dafcoe/vue-collapsible-panel'
import {format} from "date-fns";

export default {
    name: 'PublicMenuPlan',
    components: {
        Filter,
        WeekSlider,
        DesktopToggle,
        Loader,
        DayList,
        VueCollapsiblePanelGroup,
    },
    props: [
        'clientId',
        'menuId'
    ],
    data() {
        return {
            errorLoadingMeals: false,
            meals: [],
            filter: [],
            isLoading: true,
            desktopListVisible: false,
            isAccordion:true,
            viewport: 'mobile'
        }
    },
    methods: {
        handleFilterChange(filter) {
            this.filter = filter

            // synchronize with filters from user menu plan
            this.$store.commit('REPLACE_ACTIVE_FILTERS', filter)
        },
        handleSelectedWeekChange(dateFrom, dateTo, weekNumber) {
            this.isLoading = true
            this.$store.commit(
                'SET_SELECTED_WEEK',
                {
                    from: format(dateFrom, 'yyyy-MM-dd'),
                    to: format(dateTo, 'yyyy-MM-dd')
                }
            )
            this.$store.commit('SET_WEEK_NUMBER', weekNumber)

            if (!this.clientId || !this.menuId) {
                this.errorLoadingMeals = true
                console.error('MenuId or clientId missing')
            }

            this.$store.dispatch(
                'loadPublicMenu',
                {
                  clientId: this.clientId,
                  menuId: this.menuId,
                  dateFrom: dateFrom,
                  dateTo: dateTo
                }
            )
                .then((meals) => {
                    this.meals = meals
                    this.isLoading = false
                    this.errorLoadingMeals = false
                })
                .catch((error) => {
                    console.error('Error fetching meals from api: ', error)
                    this.isLoading = false
                    this.errorLoadingMeals = true
                })
        },
        getIsAccordion() {
            return !(this.desktopListVisible && this.viewport === 'desktop')
        },
        getViewport() {
            if (window.outerWidth < 1000 ) {
                this.desktopListVisible = false;
                this.$store.commit('TOGGLE_DESKTOP', false)
                this.isAccordion = true;
                return 'mobile'
            }

            return 'desktop'
        },
        handleWindowResize() {
            this.viewport = this.getViewport()
        },
    },
    beforeMount() {
        this.activeUserUuid = this.$store.getters.getUserUuid
        this.desktopListVisible = this.$store.getters['getDesktopListVisible']
        this.viewport = this.getViewport()
        this.isAccordion = this.getIsAccordion()

        // synchronize with filters from user menu plan
        this.filter = this.$store.getters.getActiveFilters ?? []
    },
    watch: {
        "$store.state.desktopListVisible"(bool) {
            this.desktopListVisible = bool
            this.isAccordion = this.getIsAccordion()
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize);
    },
}
</script>

<style lang="scss">
.header {
    padding-top: $gap;

    .menu-list-title {
        font-weight: $font-weight-black;
        font-size: $font-size-large;
    }
}

.error-message {
  height: 50vh;
}

@media all and (min-width: $desktop) {
    .desktop-list {
        display: flex;
        justify-content: space-between;

        section {
            width: 14%;
            max-width: 14%;
            flex: 0 0 auto;

            .vcp__body {
                overflow: visible;
            }

            .vcp__header {
                text-align: center;
                font-size: $font-size-xsmall;

                .vcp__header-title{
                    justify-content: center;

                    .date,
                    .day-amount-container {
                        display: block !important;
                    }
                    .date {
                        text-align: center;
                        .day-amount-container {
                            height: 50px;
                            .order-number {
                                font-size: $font-size-xxsmall;
                                display: inline-block !important;
                                line-height: 20px;
                                .badge{
                                    display: inline-block;
                                    vertical-align: middle;
                                    margin-right: 0.1rem;
                                    width: 8px;
                                    height: 8px;
                                }
                            }
                        }
                    }
                }
                .vcp__header-icon {
                    display: none !important;
                }

            }
            .vcp__body-content {
                padding: 5px;

                .menu-list-item {
                    padding: 10px 5px;

                    .menu-list-item__header {
                        font-size: $font-size-xxsmall;
                        height: auto ;
                    }
                    .menu-list-item__name {
                        font-size: $font-size-xxsmall;
                        font-weight: $weight-bold;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        height:30px;
                    }
                    .menu-list-item__description {
                        height: 45px;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        font-size: $font-size-xxsmall;
                    }
                    .menu-list-item__allergens {
                        font-size: $font-size-xxsmall;
                        padding-bottom: 5px;
                    }
                    .amount-container {
                        .price {
                            display: block;
                            text-align: center;
                            width: 100%;
                            padding-bottom: 5px;
                        }
                        .button-container {
                            width: 100%;
                            input {
                                width: 100%;
                            }
                        }
                        .error {
                            position: absolute;
                            width: 150px;
                            height: 75px;
                            background: red;
                            border: 1px solid red;
                            font-size: 12px;
                            top: 80px;
                            color: white;
                            padding: 10px;
                            left: 0;
                            z-index: 1000;
                            border-radius: $border-radius;
                            -webkit-animation: hide 1s forwards;
                            -webkit-animation-iteration-count: 1;
                            -webkit-animation-delay: 2s;
                            animation: hide 1s forwards;
                            animation-iteration-count: 1;
                            animation-delay: 2s;
                        }
                        @-webkit-keyframes hide {
                            0% {
                                opacity: 1;
                            }
                            100% {
                                opacity: 0;
                            }
                        }
                        @keyframes hide {
                            0% {
                                opacity: 1;
                            }
                            100% {
                                opacity: 0;
                            }
                        }
                    }
                }
            }
            &.vcp--expanded {
                .vcp__header {
                    font-weight: 500;
                }
            }
            .list-header {
                display: none;
            }
        }

    }
}

@media all and (min-width: $widescreen) {
    .desktop-list {
        section {
            .vcp__header {
                font-size: $font-size-medium;
                .vcp__header-title{
                    .date {
                        .day-amount-container {
                            .order-number {
                                font-size: $font-size-xsmall;
                                .badge{
                                    width: 12px;
                                    height: 12px;
                                }
                            }
                        }
                    }
                }
        }
            .vcp__body-content {
                .menu-list-item {
                    .menu-list-item__name {
                        height:40px;
                        font-size: $font-size-xsmall;
                    }
                    .menu-list-item__description {
                        height: 60px;
                        font-size: $font-size-xsmall;
                    }
                    .menu-list-item__header {
                        font-size: $font-size-xsmall;
                        height: auto ;
                    }
                    .menu-list-item__allergens {
                        font-size: $font-size-xxsmall;
                        padding-bottom: 5px;
                    }
                }
            }
        }

    }
}

@media all and (min-width: $fullhd) {
    .desktop-list {
        section {
            .vcp__header {
                .vcp__header-title{
                    .date {
                        width: 80%;
                    }
                }
            }
            .vcp__body-content {
                .menu-list-item {
                    .menu-list-item__description {
                        height: 60px;
                    }
                }
            }
        }

    }
}
</style>
